import { Box, Group, Stack, Text } from '@mantine/core';

import SelectableCard from '@/components/SelectableCard';

import ProductBadge from '../components/ProductBadge';
import StatusIcon from '../components/StatusIcon';
import type { VendorAvailabilityListItem } from '../types';
import { getListItemStatus, getStatusText, getStatusColor } from '../helpers';

type RestaurantListItemProps = {
  item: VendorAvailabilityListItem;
  isSelected: boolean;
  onSelect: () => void;
};

const RestaurantListItem: React.FC<RestaurantListItemProps> = ({ item, isSelected, onSelect }) => {
  const statusText = getStatusText(item);
  const { isActionRequired } = getListItemStatus(item);

  return (
    <SelectableCard isSelected={isSelected} onSelect={onSelect}>
      <Group gap={4} wrap="nowrap" align="flex-start">
        <Box>
          <StatusIcon item={item} />
        </Box>
        <Stack gap={0} flex={1} miw={0} mt={2}>
          <Text fw={700} size="sm" c="black" lh={1.3}>
            {item.internalName}
          </Text>
          <Group gap={8} mt={2}>
            <ProductBadge productType={item.productType} />
            {statusText && (
              <Text
                size="xs"
                fw={isActionRequired ? 600 : 400}
                c={getStatusColor(item)}
                truncate="end"
              >
                {statusText}
              </Text>
            )}
          </Group>
        </Stack>
      </Group>
    </SelectableCard>
  );
};

export default RestaurantListItem;
